import { pushNotification , getNotification , markAsSeen } from "@/api/notifications";

export default {
    namespaced: true,
    state: {
      notifications: [],
      isNotificationFormOpen: false, // Whether the notification form (drawer) is open
    },
    mutations: {
      // Add new notification to the list
      ADD_NOTIFICATION(state, notification) {
        state.notifications.push(notification);
      },
      // Toggle notification form drawer
      TOGGLE_NOTIFICATION_FORM(state) {
        
        state.isNotificationFormOpen = !state.isNotificationFormOpen;
      },
      SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications;
      },
    },
    actions: {
      async fetchNotifications({ commit } , page) {
        try {
          const notifications = await getNotification(page); // Fetch notifications from the API
          commit('SET_NOTIFICATIONS', notifications); // Commit them to the state
          console.log(notifications);
        } catch (error) {
          console.error('Failed to fetch notifications:', error);
        }
      },
      // Trigger push notification API
      async pushNotification({ commit }, notificationData) {
        try {
          const notification = await pushNotification(notificationData);
          commit('ADD_NOTIFICATION', notification);
        } catch (e) {
          console.error("Error pushing notification:", e);
        }
      },
      // Toggle the notification form visibility
      async toggleNotificationForm({ commit }) {
        commit('TOGGLE_NOTIFICATION_FORM');
      },
      async markAllNotificationsAsSeen({ commit }) {
        try{
          const notifications = await markAsSeen();
          commit('SET_NOTIFICATIONS', notifications);
        } catch(e){
          console.error('Failed to fetch notifications:', e);
        }
      },
    },
    getters: {
      notifications: (state) => state.notifications,
      isNotificationFormOpen: (state) => state.isNotificationFormOpen,
    },
  };
  